import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { RendererJSON, StaticTable } from "./renderer";
import { getBuilderAttributes } from "./builderAttributes";
import {
  DDABreadCrumbs,
  DDAHeader,
  EventVariantCard,
  FileDownloadRow,
  ImageCard,
  PaginationRenderer,
  Tab,
  TabContent,
  TableItemsRenderer,
  TeamMemberCard,
  TestimonialCard,
} from "./components";
import { getTranlation, getValue } from "./function";
import MediaCenter from "../mediaCenter/mediaCenter";
import Services from "../services/services";
import MediaCenterDetails from "../mediaCenter/mediaCenterDetail";
import FAQs from "../faq/faq";
import Circulars from "../circular/circular";
import OverviewHealthinDubai from "../overviewHealth/overviewHealthinDubai";
import HealthPromotionAndAwareness from "../healthAndPromotionAwareness/healthAndPromotionAwareness";
import HealthRegulatoryDocuments from "../regulatoryDocument/regulatoryDocument";
import { Home, HomeNews, HomeApp } from "../Home/home";
import Search from "../search/search";
import Pagereview from "../../components/pageReview/Pagereview";
import ContactDHA from "../contactUs/contactUs";
import ServiceDetails from "../services/serviceDetails";
import PublicationsAndMedicalLibrary from "../publications/publicationsAndMedicalLibrary";
import WorkPlacement from "../workPlacement/workPlacement";
import DubaiMedicalRegistry from "../medicalRegistry/medicalRegistry";

export const FormContext = createContext();

const ConfigDecider = ({ type, children, isHome }) => {
  if (type === "form") {
    return <form>{children}</form>;
  }
  return <div>{children}</div>;
};

const custom_components_list = {
  TestimonialCard,
  FileDownloadRow,
  TeamMemberCard,
  ImageCard,
  EventVariantCard,
};

const Renderer = React.memo(
  ({
    config = {},
    index_identifier = 0,
    parent_index,
    parent_config = {},
    parent_data,
  }) => {
    const { configuration, currentLang } = useContext(FormContext);
    const config_props =
      currentLang === "en"
        ? { ...config }
        : { ...getTranlation({ config: config }) };
    const builderAttributes = getBuilderAttributes(config_props);
    const renderWithBuilderWrapper = (children) => (
      <div {...builderAttributes}>{children}</div>
    );

    if (!!config_props.isDisabled) {
      return <></>;
    }

    switch (config_props?.type) {
      case "review":
        return renderWithBuilderWrapper(<Pagereview />);
      case "custom_code":
        return (
          <>
            <div
              {...builderAttributes}
              dangerouslySetInnerHTML={{
                __html:
                  currentLang === "en"
                    ? config?.props.html
                    : config?.props.html_ar,
              }}
            ></div>
          </>
        );
      case "static_promotion_awareness":
        return renderWithBuilderWrapper(
          <HealthPromotionAndAwareness
            config={{ ...config, ...config?.props }}
          />
        );
      case "static_search":
        return renderWithBuilderWrapper(
          <Search config={{ ...config, ...config?.props }} />
        );
      case "static_overview_health":
        return renderWithBuilderWrapper(
          <OverviewHealthinDubai config={{ ...config, ...config?.props }} />
        );
      case "static_circular":
        return renderWithBuilderWrapper(
          <Circulars config={{ ...config, ...config?.props }} />
        );
      case "static_faq":
        return renderWithBuilderWrapper(
          <FAQs config={{ ...config, ...config?.props }} />
        );
      case "static_services":
        return renderWithBuilderWrapper(
          <Services config={{ ...config, ...config?.props }} />
        );
      case "static_service_detail":
        return renderWithBuilderWrapper(
          <ServiceDetails config={{ ...config, ...config?.props }} />
        );
      case "static_news_detail":
        return renderWithBuilderWrapper(
          <MediaCenterDetails config={{ ...config, ...config?.props }} />
        );
      case "static_news":
        return renderWithBuilderWrapper(
          <MediaCenter config={{ ...config, ...config?.props }} />
        );
      case "static_new_detail":
        return <></>;
      case "static_contactUs":
        return renderWithBuilderWrapper(
          <ContactDHA config={{ ...config, ...config?.props }} />
        );
      case "static_publications":
        return renderWithBuilderWrapper(
          <PublicationsAndMedicalLibrary
            config={{ ...config, ...config?.props }}
          />
        );
      case "static_workPlacement":
        return renderWithBuilderWrapper(
          <WorkPlacement config={{ ...config, ...config?.props }} />
        );
      case "static_medicalRegistry":
        return renderWithBuilderWrapper(
          <DubaiMedicalRegistry config={{ ...config, ...config?.props }} />
        );
      case "static_regulatory":
        return renderWithBuilderWrapper(
          <HealthRegulatoryDocuments config={{ ...config, ...config?.props }} />
        );
      case "static_home":
        return renderWithBuilderWrapper(
          <Home config={{ ...config, ...config?.props }} />
        );
      case "static_home_news":
        return renderWithBuilderWrapper(
          <HomeNews config={{ ...config, ...config?.props }} />
        );
      case "static_home_app":
        return renderWithBuilderWrapper(
          <HomeApp config={{ ...config, ...config?.props }} />
        );
      case "div":
        return (
          <div
            {...builderAttributes}
            className={`${
              (Array.isArray(config_props?.prebuildClass) &&
                config_props?.prebuildClass.join(" ")) ||
              ""
            } ${
              config_props?.text_color !== undefined &&
              config_props?.text_color !== ""
                ? "!text-[" + config_props?.text_color + "]"
                : ""
            } ${
              config_props?.background_color !== undefined &&
              config_props?.background_color !== ""
                ? "!bg-[" + config_props?.background_color + "]"
                : ""
            } ${config_props?.classname || ""}`}
          >
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={
                      parent_index ? parent_index : index_identifier
                    }
                    index_identifier={index}
                  />
                ))
              : null}
          </div>
        );
      case "custom_components": {
        const DynamicComponent =
          custom_components_list?.[config_props?.custom_components] || "";
        if (DynamicComponent === "") return null;
        return (
          <DynamicComponent
            {...config_props?.props}
            builderAttributes={builderAttributes}
          >
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null}
          </DynamicComponent>
        );
      }
      case "icon": {
        return (
          <>
            {config_props?.icon &&
            config_props?.icon !== "" &&
            config_props?.icon_library === "material" ? (
              <span
                {...builderAttributes}
                className={`text-primary shrink-0 material-symbols-${
                  config_props?.icon_type
                } ${config_props?.classname || "text-4xl"}`}
              >
                {config_props?.icon}
              </span>
            ) : (
              <div
                {...builderAttributes}
                dangerouslySetInnerHTML={{
                  __html:
                    config_props?.icon && config_props?.icon !== ""
                      ? config_props?.icon
                      : "",
                }}
              />
            )}
          </>
        );
      }
      case "htmlTag": {
        const SizeComponents =
          config_props?.tag && config_props?.tag !== ""
            ? config_props?.tag
            : "div";
        if (SizeComponents === "hr" || SizeComponents === "br")
          return (
            <SizeComponents
              className={config_props?.classname || ""}
              {...builderAttributes}
            />
          );
        return (
          <SizeComponents
            className={`${
              (Array.isArray(config_props?.prebuildClass) &&
                config_props?.prebuildClass.join(" ")) ||
              ""
            } ${config_props?.classname || ""}`}
            {...config_props?.props}
            {...builderAttributes}
          >
            {config_props?.text && config_props?.text !== ""
              ? config_props?.text
              : ""}
            {config_props?.text_params && config_props?.text_params !== ""
              ? getValue({
                  type_identifier: {
                    params: JSON.parse(config_props?.text_params).map((p) =>
                      p
                        .replace(/{parentIndex}/g, parent_index)
                        .replace(/{index}/g, parent_index + 1)
                    ),
                  },
                  currentElement: parent_data
                    ? parent_data
                    : configuration?.[parent_config?._id],
                })
              : ""}
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null}
          </SizeComponents>
        );
      }
      case "image":
        const { classname, ...rest } = config_props ?? {};
        return (
          <img
            {...rest}
            {...builderAttributes}
            onClick={
              typeof config_props?.onClick === "string"
                ? eval(config_props?.onClick)
                : config_props?.onClick
            }
            onError={eval(config_props?.onError)}
            className={config_props?.classname || ""}
            src={
              config_props?.src
                ? config_props?.src
                : config_props?.url
                ? config_props?.url
                : ""
            }
            alt={config_props?.alt}
          />
        );
      case "heading": {
        const SizeComponents = config_props?.size || "h1";
        return (
          <SizeComponents
            {...builderAttributes}
            className={`${
              (Array.isArray(config_props?.prebuildClass) &&
                config_props?.prebuildClass.join(" ")) ||
              ""
            } ${
              config_props?.text_color !== undefined &&
              config_props?.text_color !== ""
                ? "!text-[" + config_props?.text_color + "]"
                : ""
            } ${
              config_props?.background_color !== undefined &&
              config_props?.background_color !== ""
                ? "!bg-[" + config_props?.background_color + "]"
                : ""
            } ${config_props?.classname || ""}`}
            // style={{ marginBottom: "10px" }}
          >
            {config_props?.text && config_props?.useLinker
              ? configuration?.[config_props?.text]
              : config_props?.text !== ""
              ? (
                  config_props.text.split("<br />") ||
                  config_props.text.split("<br/>")
                ).map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    {config_props.text.split("<br />")?.length !== index + 1 &&
                    config_props.text.includes("<br />") ? (
                      <br />
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ))
              : ""}
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null}
          </SizeComponents>
        );
      }
      case "tabcontent": {
        return (
          <TabContent
            config={config_props}
            index_identifier={index_identifier}
            parent_index={parent_index}
          >
            {config_props?.isShow_title &&
              config_props?.title &&
              config_props?.title !== "" && (
                <Renderer
                  config={{
                    type: "paragraph",
                    size: config_props?.size,
                    text: config_props?.title,
                    classname: "body mt-7",
                  }}
                  key={index_identifier}
                  index_identifier={index_identifier}
                />
              )}
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null}
          </TabContent>
        );
        // if (config?.useLinker)
        //   return (
        //     configuration?.[config?.linker] === config?.title && (
        //       <div>
        //         {config?.isShow_title && config?.title && (
        //           <Renderer
        //             config={{
        //               type: "paragraph",
        //               size: config?.size,
        //               text: config?.title,
        //               classname: "body mt-7",
        //             }}
        //             key={index_identifier}
        //             index_identifier={index_identifier}
        //           />
        //         )}
        //         {config?.children?.length > 0
        //           ? (config?.children || [])?.map((renderer, index) => (
        //               <Renderer
        //                 config={{ ...renderer }}
        //                 key={index}
        //                 parent_index={index_identifier}
        //                 index_identifier={index}
        //               />
        //             ))
        //           : null}
        //       </div>
        //     )
        //   );
        // else
        //   return (
        //     configuration?.[parent_index] === index_identifier && (
        //       <div>
        //         {config?.isShow_title && (
        //           <Renderer
        //             config={{
        //               type: "paragraph",
        //               size: config?.size,
        //               text: config?.title,
        //               classname: "body mt-7",
        //             }}
        //             key={index_identifier}
        //             index_identifier={index_identifier}
        //           />
        //         )}
        //         {config?.children?.length > 0
        //           ? (config?.children || [])?.map((renderer, index) => (
        //               <Renderer
        //                 config={{ ...renderer }}
        //                 key={index}
        //                 parent_index={index_identifier}
        //                 index_identifier={index}
        //               />
        //             ))
        //           : null}
        //       </div>
        //     )
        //   );
      }
      case "list" || "list_item": {
        const DynamicComponent =
          config_props?.type_identifier && config_props?.type_identifier !== ""
            ? config_props?.type_identifier
            : "";
        return (
          <DynamicComponent
            {...builderAttributes}
            className={config_props?.classname || ""}
          >
            {config_props?.text && config_props?.text !== ""
              ? config_props?.text
              : ""}
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null}
          </DynamicComponent>
        );
      }
      case "table": {
        return (
          <TableItemsRenderer config={config_props || {}}>
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_config={{ ...config_props }}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null}
          </TableItemsRenderer>
        );
      }
      case "tableItems": {
        const DynamicComponent =
          config_props?.type_identifier && config_props?.type_identifier !== ""
            ? config_props?.type_identifier
            : "";

        let tableSpan = {};

        if (config_props?.rowSpan)
          tableSpan = { ...tableSpan, rowspan: config_props?.rowSpan || "" };
        if (config_props?.colSpan)
          tableSpan = { ...tableSpan, colspan: config_props?.colSpan || "" };
        if (DynamicComponent === "") return;
        return (
          <DynamicComponent
            {...tableSpan}
            {...builderAttributes}
            className={config_props?.classname || ""}
          >
            {config_props?.text && config_props?.text !== ""
              ? config_props?.text?.match(/\{([^}]+)\}/g)
                ? config_props?.text?.replace(/\{index\}/g, parent_index + 1)
                : config_props?.text
              : ""}
            {config_props?.text_params && config_props?.text_params !== ""
              ? getValue({
                  type_identifier: {
                    params: JSON.parse(config_props?.text_params).map((p) =>
                      p
                        .replace(/{parentIndex}/g, parent_index)
                        .replace(/{index}/g, parent_index + 1)
                    ),
                  },
                  currentElement: parent_data
                    ? parent_data
                    : configuration?.[`${parent_config?._id}_data`],
                })
              : ""}
            {config_props?.parent_params && config_props?.parent_params !== ""
              ? Array.isArray(
                  getValue({
                    type_identifier: {
                      params: JSON.parse(config_props?.parent_params).map((p) =>
                        p
                          .replace(/{parentIndex}/g, parent_index)
                          .replace(/{index}/g, parent_index + 1)
                      ),
                    },
                    currentElement:
                      configuration?.[`${parent_config?._id}_data`],
                  })
                ) &&
                getValue({
                  type_identifier: {
                    params: JSON.parse(config_props?.parent_params).map((p) =>
                      p
                        .replace(/{parentIndex}/g, parent_index)
                        .replace(/{index}/g, parent_index + 1)
                    ),
                  },
                  currentElement: configuration?.[`${parent_config?._id}_data`],
                })?.map((tableItems, parentIndex) =>
                  config_props?.children?.length > 0
                    ? (config_props?.children || [])?.map((renderer, index) => {
                        return (
                          <Renderer
                            config={{ ...renderer }}
                            key={index}
                            parent_config={{ ...parent_config }}
                            parent_index={parentIndex}
                            index_identifier={index}
                            parent_data={tableItems}
                          />
                        );
                      })
                    : null
                )
              : config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={parent_index}
                    parent_config={{ ...parent_config }}
                    index_identifier={index}
                    parent_data={parent_data}
                  />
                ))
              : ""}
          </DynamicComponent>
        );
      }
      case "linking":
        return (
          <a
            {...builderAttributes}
            className={`${
              (Array.isArray(config_props?.prebuildClass) &&
                config_props?.prebuildClass.join(" ")) ||
              ""
            } ${
              config_props?.text_color !== undefined &&
              config_props?.text_color !== ""
                ? "!text-[" + config_props?.text_color + "]"
                : ""
            } ${
              config_props?.background_color !== undefined &&
              config_props?.background_color !== ""
                ? "!bg-[" + config_props?.background_color + "]"
                : ""
            } ${config_props?.classname || ""}`}
            href={config_props?.href || ""}
            rel={config_props?.rel || ""}
            target={config_props?.target || ""}
          >
            {config_props?.text &&
              config_props?.text !== "" &&
              config_props?.text}
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null}
          </a>
        );

      case "dda-header": {
        return (
          <DDAHeader
            config={config_props}
            index_identifier={index_identifier}
          />
        );
      }
      case "dda-tabs":
        return (
          <>
            <Tab config={config_props} index_identifier={index_identifier} />
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={config_props?._id}
                    index_identifier={index}
                  />
                ))
              : null}
          </>
        );
      case "paragraph": {
        return (
          <p
            {...builderAttributes}
            className={`${
              (Array.isArray(config_props?.prebuildClass) &&
                config_props?.prebuildClass.join(" ")) ||
              ""
            } ${
              config_props?.text_color !== undefined &&
              config_props?.text_color !== ""
                ? "!text-[" + config_props?.text_color + "]"
                : ""
            } ${
              config_props?.background_color !== undefined &&
              config_props?.background_color !== ""
                ? "!bg-[" + config_props?.background_color + "]"
                : ""
            } ${config_props?.classname || ""}`}
            // style={{ marginBottom: "10px" }}
          >
            {(config_props?.text &&
            config_props?.text !== "" &&
            config_props?.text &&
            config_props?.text?.match(/\{([^}]+)\}/g)
              ? config_props?.text?.replace(/\{index\}/g, parent_index + 1)
              : config_props.text
                  .split("<br />" || "<br/>")
                  .map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {config_props.text.split("<br />" || "<br/>")?.length ===
                      index + 1 ? (
                        ""
                      ) : (
                        <br />
                      )}
                    </React.Fragment>
                  ))) || ""}
            {config_props?.text_params && config_props?.text_params !== ""
              ? getValue({
                  type_identifier: {
                    params: JSON.parse(config_props?.text_params).map((p) =>
                      p
                        .replace(/{parentIndex}/g, parent_index)
                        .replace(/{index}/g, parent_index + 1)
                    ),
                  },
                  currentElement: parent_data
                    ? parent_data
                    : configuration?.[`${parent_config?._id}_data`],
                })
              : ""}
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null}
          </p>
        );
      }
      case "richtext": {
        debugger;
        return (
          <div
            {...builderAttributes}
            className={config_props?.classname || ""}
            dangerouslySetInnerHTML={{ __html: config_props?.text || "" }}
            // style={{ marginBottom: "10px" }}
          >
            {/* {(config_props?.text &&
            config_props?.text !== "" &&
            config_props?.text &&
            config_props?.text?.match(/\{([^}]+)\}/g)
              ? config_props?.text?.replace(/\{index\}/g, parent_index + 1)
              : config_props.text
                  .split("<br />" || "<br/>")
                  .map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {config_props.text.split("<br />" || "<br/>")?.length ===
                      index + 1 ? (
                        ""
                      ) : (
                        <br />
                      )}
                    </React.Fragment>
                  ))) || ""} */}
            {/* {config_props?.text_params && config_props?.text_params !== ""
              ? getValue({
                  type_identifier: {
                    params: JSON.parse(config_props?.text_params).map((p) =>
                      p
                        .replace(/{parentIndex}/g, parent_index)
                        .replace(/{index}/g, parent_index + 1)
                    ),
                  },
                  currentElement: parent_data
                    ? parent_data
                    : configuration?.[`${parent_config?._id}_data`],
                })
              : ""} */}
            {/* {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null} */}
          </div>
        );
      }
      case "html": {
        return (
          <div
            {...builderAttributes}
            dangerouslySetInnerHTML={{ __html: config_props?.html || "" }}
          ></div>
        );
      }
      case "pagination": {
        return <PaginationRenderer config={config_props} />;
      }
      case "dda-breadcrumb": {
        return (
          <DDABreadCrumbs
            config={config_props || {}}
            breadCrumb={config_props?.breadCrumb_item || []}
            key={JSON.stringify(config_props?.props?.["data-breadcrumbs"])}
          >
            {config_props?.children?.length > 0
              ? (config_props?.children || [])?.map((renderer, index) => (
                  <Renderer
                    config={{ ...renderer }}
                    key={index}
                    parent_config={{ ...config_props }}
                    parent_index={index_identifier}
                    index_identifier={index}
                  />
                ))
              : null}
          </DDABreadCrumbs>
        );
      }
      default:
        if (config_props?.type?.includes("dda")) {
          const DynamicComponent =
            config_props?.type && config_props?.type !== ""
              ? config_props?.type
              : "";
          let tempConfig = {
            ...config_props?.props,
          };
          if (tempConfig?.["chip_list"]) {
            console.log(tempConfig);

            tempConfig = {
              ...tempConfig,
              ["chip_list"]: tempConfig?.["chip_list"],
            };
          }
          if (config_props?.props?.isReplace) {
            tempConfig = {
              ...tempConfig,
              onclick: eval(
                config_props?.props?.onclick?.replace(
                  config_props?.props?.onclick?.match(/\[([^\]]+)\]/)?.[0],
                  getValue({
                    type_identifier: {
                      params: JSON.parse(
                        config_props?.props?.onclick?.match(/\[([^\]]+)\]/)?.[0]
                      ),
                    },
                    currentElement: parent_data
                      ? parent_data
                      : configuration?.[`${parent_config?._id}_data`],
                  })
                )
              ),
            };
          }
          if (typeof config_props?.props?.onclick === "string") {
            tempConfig = {
              ...tempConfig,
              onclick: eval(config_props?.props?.onclick),
            };
          }

          console.log(tempConfig, "check");

          return (
            <DynamicComponent {...tempConfig} {...builderAttributes}>
              {config_props?.children?.length > 0
                ? (config_props?.children || [])?.map((renderer, index) => (
                    <Renderer
                      config={{ ...renderer }}
                      key={index}
                      parent_index={index_identifier}
                      index_identifier={index}
                    />
                  ))
                : null}
            </DynamicComponent>
          );
        } else {
          return (
            <div
              {...builderAttributes}
              className={`${
                (Array.isArray(config_props?.prebuildClass) &&
                  config_props?.prebuildClass.join(" ")) ||
                ""
              } ${
                config_props?.text_color !== undefined &&
                config_props?.text_color !== ""
                  ? "!text-[" + config_props?.text_color + "]"
                  : ""
              } ${
                config_props?.background_color !== undefined &&
                config_props?.background_color !== ""
                  ? "!bg-[" + config_props?.background_color + "]"
                  : ""
              } ${config_props?.classname || ""}`}
            >
              {config_props?.children?.length > 0
                ? (config_props?.children || [])?.map((renderer, index) => (
                    <Renderer
                      config={{ ...renderer }}
                      key={index}
                      parent_index={
                        parent_index ? parent_index : index_identifier
                      }
                      index_identifier={index}
                    />
                  ))
                : null}
            </div>
          );
        }
    }
  }
);

const CMSRenderer = React.memo(({ JSONDATA, LANGUAGE }) => {
  const [tabType, setTabType] = useState("dda-horizontal-tab");
  const [configuration, setConfiguration] = useState({});
  const [currentLang, setCurrentLang] = useState(LANGUAGE || "ar");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setTabType("dda-vertical-tab");
      } else {
        setTabType("dda-horizontal-tab");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <FormContext.Provider
      value={{
        tabType,
        setTabType,
        configuration,
        setConfiguration,
        currentLang,
        setCurrentLang,
      }}
    >
      <ConfigDecider>
        {(JSONDATA?.blocks || [])?.map((render, index) => (
          <Renderer
            config={{ ...render }}
            key={index}
            index_identifier={index}
          />
        ))}
      </ConfigDecider>
    </FormContext.Provider>
  );
});

export default CMSRenderer;
